import type { Option } from "../constants";

export interface AdvancedTriggerApiItem {
	id: number | string;
	friendlyName?: string;
	triggerName?: string;
	description?: string;
	active?: boolean;
	dataFieldType?: { id: number; name: string };
	dataFieldTypeId?: number;
}

export function deriveAdvancedTriggerOptions(items?: AdvancedTriggerApiItem[]): Option[] {
	if (!items?.length) return [];
	return items.map((item) => ({
		label: item.friendlyName ?? item.triggerName ?? String(item.id),
		value: String(item.id),
		dataType: item.dataFieldType?.name,
		triggerName: item.triggerName,
	}));
}
